<script setup>
import { Link } from '@inertiajs/vue3';
import Button from '@/Components/Button.vue';

const features = [
    {
        icon: '/images/home/chat.svg',
        title: 'Chater',
        description: 'Le réseau social des gays de Lyon',
        highlighted: false
    },
    {
        icon: '/images/home/meet.svg',
        title: 'Se rencontrer',
        description: 'Le réseau social des gays de Lyon',
        highlighted: true
    },
    {
        icon: '/images/home/live.svg',
        title: 'Salon live',
        description: 'Le réseau social des gays de Lyon',
        highlighted: false
    },
    {
        icon: '/images/home/party.svg',
        title: 'Soirée',
        description: 'Le réseau social des gays de Lyon',
        highlighted: false
    },
    {
        icon: '/images/home/travel.svg',
        title: 'Voyage',
        description: 'Le réseau social des gays de Lyon',
        highlighted: false
    },
    {
        icon: '/images/home/groups.svg',
        title: 'Groupes & pages',
        description: 'Le réseau social des gays de Lyon',
        highlighted: false
    }
];
</script>

<template>
    <section class="relative py-20 lg:py-32 overflow-hidden" style="background-color: #F0F5FB;">
        <!-- Top Decoration SVG -->
        <div class="absolute top-0 left-1/5 lg:left-1/4 w-32 lg:w-40 transform -translate-x-1/2">
            <img src="/images/home/decoration-1.svg" alt="" class="w-full" />
        </div>

        <div class="container mx-auto px-4">
            <div class="grid lg:grid-cols-2 gap-12 items-center">
                <!-- Left Column - Image -->
                <div class="relative max-w-md mx-auto lg:mx-0" data-aos="fade-right">
                    <img
                        src="/images/home/section-2.png"
                        alt="Community"
                        class="w-full h-auto"
                    />
                </div>

                <!-- Right Column - Features -->
                <div data-aos="fade-left">
                    <!-- Section Header -->
                    <div class="mb-8">
                        <h2 class="text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 leading-tight">
                            Toutes vos envies au <span class="bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent">même endroit</span>
                        </h2>
                        <p class="text-base text-gray-600 leading-relaxed">
                            Fonctionnalités simples et pratiques pour trouver des lieux, <strong>événements</strong> et <strong>rencontres</strong> qui vous ressemblent.
                        </p>
                    </div>

                    <!-- Features Grid -->
                    <div class="grid md:grid-cols-2 gap-4 mb-8">
                        <div
                            v-for="(feature, index) in features"
                            :key="index"
                            class="flex items-start gap-4 p-4 bg-white transition-all duration-300"
                            style="border-radius: 0 2rem 0 2rem; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);"
                            data-aos="fade-up"
                            :data-aos-delay="index * 50"
                        >
                            <!-- Icon -->
                            <div class="w-12 h-12 flex items-center justify-center flex-shrink-0">
                                <img :src="feature.icon" :alt="feature.title" class="w-10 h-10" />
                            </div>

                            <!-- Content -->
                            <div>
                                <h3 class="text-lg font-bold mb-1">{{ feature.title }}</h3>
                                <p class="text-sm text-gray-600">{{ feature.description }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- CTA Button -->
                    <div class="mt-8">
                        <Button
                            as="link"
                            :href="route('register')"
                            class="!rounded-full px-8 py-3"
                        >
                            Découvrir
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
